import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _ProductiveProcessType } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectProductiveProcessType = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ProductiveProcessType)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {

        instance.getProductiveProcessTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <>
            <label>{label ?? "Procesos Productivos"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDProductiveProcessType} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}